import appConfig from '../config/appConfig';
import * as reconnectGuideTypes from '../consts/app/reconnectGuideTypes';
import ModalTypes from '../enums/app/modalTypes';
import {showReconnectDeviceGuideModalAction} from '../state/ducks/modal';
import {selectIsReconnectGuideEnabled} from '../state/selectors/global';
import {selectDeviceConnectionStatus} from '../state/selectors/iotDevice';
import {dispatch, getState} from '../state/store';
import connectivityService from './device/connectivityService';
import iotDeviceConnectionStatusService from './iotDevice/iotDeviceConnectionStatusService';
import modalService from './modalService';

const showFailedReconnectDeviceGuide = ({isReconnectFailed} = {}) => {
    const isReconnectGuideEnabled = selectIsReconnectGuideEnabled(getState());
    const isReconnectDeviceGuideEnabled = appConfig.getIsReconnectDeviceGuideEnabled();
    const isBle = connectivityService.isBle();
    const isVisibleDeviceConnectionDetector =
        ((isReconnectDeviceGuideEnabled && isReconnectGuideEnabled) || isReconnectFailed) && isBle;

    if (isVisibleDeviceConnectionDetector) {
        const connectionStatus = selectDeviceConnectionStatus(getState());
        const isDeviceReady = iotDeviceConnectionStatusService.isDeviceReady(connectionStatus);

        if (!isDeviceReady) {
            modalService.hideModal(ModalTypes.RECONNECT_DEVICE_GUIDE);
            dispatch(
                showReconnectDeviceGuideModalAction({
                    guideType: isReconnectFailed ? reconnectGuideTypes.CRITICAL : reconnectGuideTypes.NOT_CRITICAL,
                    isReconnectFailed,
                })
            );
        }
    }
};

export default {showFailedReconnectDeviceGuide};
